import React from 'react';
import { useSelector } from 'react-redux';

// Constants
import { meetingItemTypes } from 'Shared/constants/constants';

// Helpers
import WorkspaceRecentUpdatesHelper from 'Shared/model_helpers/WorkspaceRecentUpdates.helper';
import MeetingItemHelpers from 'Shared/model_helpers/MeetingItem.helper';

// Components
import NotificationHeader from './partials/NotificationHeader';
import NotificationMeetingItem from './partials/NotificationMeetingItem';

// Selectors
import * as meetingItemSelectors from 'Shared/selectors/MeetingItems.selectors';

type Props = {
  notification;
};

const NewItemCreated = ({ notification }: Props) => {
  const meetingItemUuid = WorkspaceRecentUpdatesHelper.getMeetingItemUuid(notification);

  const meetingItem = useSelector(state => meetingItemSelectors.getMeetingItemByUuid(state, { meetingItemUuid })).get(
    meetingItemUuid
  );

  const itemType = MeetingItemHelpers.getItemType(meetingItem);

  if (!meetingItem) return null;

  const label = `created a new ${meetingItemTypes[itemType].toLowerCase()}`;

  const baseClassName = 'NewItemCreated';

  return (
    <div className={baseClassName}>
      <NotificationHeader notification={notification} label={label} />
      <NotificationMeetingItem meetingItem={meetingItem} />
    </div>
  );
};

export default NewItemCreated;
